import { Colors } from '@estee/elc-base-theme';

export const iconTheme = `
    stroke: ${Colors.primary700};
`;

export const accordionHeaderBorderTheme = `
    border-color: ${Colors.primary300};
`;

export const RadioSlideTheme = `
    border-color: ${Colors.blackDisabledEmphasis};
`;

export const contentDivTheme = `
    border-top-color: ${Colors.primary300};
`;

export const panelTheme = `
    background-color: ${Colors.white};
`;
